// Reistijd vanaf kantoor bij een callsheet-locatie, blok "Waar" (Joris 21 okt 2026).
// De engine (/api/v1/reistijd/vanaf-kantoor, Azure Maps) rekent met de draaidag + begintijd
// als aankomst; zonder sleutel of bij een storing komt er alleen de Route-link (of niets).
// Zelfde bestand op develop en main: praat direct met de engine, net als het weer.
import React, { useEffect, useState } from 'react';
import { Link, Tooltip, Typography } from '@mui/material';
import { AI_ENGINE_URL } from '../../utils/apiConfig';
import { authFetch } from '../../utils/authHelpers';

export const reistijdUrl = (adres, datum, aankomst) => {
  const q = new URLSearchParams({ adres: adres || '' });
  if (/^\d{4}-\d{2}-\d{2}$/.test(datum || '')) q.set('datum', datum);
  if (/^\d{1,2}:\d{2}$/.test(aankomst || '')) q.set('aankomst', aankomst);
  return `${AI_ENGINE_URL}/api/v1/reistijd/vanaf-kantoor?${q.toString()}`;
};

/** Antwoord van de engine, of null zolang er niets is (laden, fout). */
export function useReistijd(adres, datum, aankomst) {
  const [data, setData] = useState(null);
  const url = adres && adres.trim().length >= 4 ? reistijdUrl(adres.trim(), datum, aankomst) : '';
  useEffect(() => {
    setData(null);
    if (!url) return undefined;
    let actief = true;
    authFetch(url)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (actief) setData(d || null); })
      .catch(() => { /* bewust stil: de reistijd is een extraatje */ });
    return () => { actief = false; };
  }, [url]);
  return data;
}

export default function ReistijdRegel({ adres, datum, aankomst, kleur = '#64748b' }) {
  const r = useReistijd(adres, datum, aankomst);
  if (!r || (!r.beschikbaar && !r.route_url)) return null;
  const route = r.route_url && (
    <Link href={r.route_url} target="_blank" rel="noopener noreferrer" underline="hover" sx={{ color: 'inherit', fontWeight: 600 }}>
      {r.beschikbaar ? 'Route' : 'Route vanaf kantoor'}
    </Link>
  );
  return (
    <Typography variant="body2" data-testid="reistijd" sx={{ color: kleur }}>
      {r.beschikbaar && (
        <>
          <span aria-hidden>🚗 </span>{r.samenvatting}
          {r.vertrek_uiterlijk && (
            <Tooltip title={`Aankomst ${aankomst} (begintijd), incl. ${r.marge_minuten || 15} min marge voor uitladen en parkeren${r.met_verkeer ? '' : '; zonder verkeersverwachting'}`}>
              <span> · vertrek uiterlijk <b>{r.vertrek_uiterlijk}</b>{r.vertrek_dag_ervoor ? ' (dag ervoor)' : ''}</span>
            </Tooltip>
          )}
          {route && ' · '}
        </>
      )}
      {route}
    </Typography>
  );
}
